import { ClientBaseAnswer as WebClientBaseAnswer } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { ClientBaseAnswer as AdminClientBaseAnswer } from "AdminServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { useEnumAnswer } from "./answer-enum";
import { ClientBaseAnswerValue } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers/ClientBaseAnswerAbstraction";
import i18next from "i18next";
export const observedAttributes = ["q11e", "questionId"];
export const useShadowDOM = false;
export const name = "ww-answer-clientbase";
export class ClientBaseChangeEvent extends CustomEvent {
  constructor(detail) {
    super("change", { detail, bubbles: true });
  }
}
export const Component = (host) => {
  const props = {
    q11e: host.q11e,
    questionId: host.questionId
  };
  const dispatch = (answer) => {
    host.dispatchEvent(
      new ClientBaseChangeEvent({
        answer: getAnswer(answer)
      })
    );
  };
  const getAnswer = (answer) => {
    var _a;
    if ((_a = props.q11e) == null ? void 0 : _a.isAdmin) {
      return new AdminClientBaseAnswer({ Value: answer.Value, QuestionId: props.questionId });
    }
    return new WebClientBaseAnswer({ Value: answer.Value, QuestionId: props.questionId });
  };
  const enumHook = useEnumAnswer({
    dataSource: [
      { value: ClientBaseAnswerValue.B2B, label: i18next.t("B2B") },
      { value: ClientBaseAnswerValue.B2C, label: i18next.t("B2C") },
      { value: ClientBaseAnswerValue.Both, label: i18next.t("Both") }
    ],
    isMultiSelect: false,
    questionId: props.questionId,
    q11e: props.q11e,
    dispatch
  });
  return enumHook.mainTemplate;
};
